/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Facts_Xlsx_ValueInputs */

const en_gc_resources_facts_xlsx_value = /** @type {(inputs: Gc_Resources_Facts_Xlsx_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.xlsx`)
};

const zh_gc_resources_facts_xlsx_value = /** @type {(inputs: Gc_Resources_Facts_Xlsx_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.xlsx`)
};

/**
* | output |
* | --- |
* | ".xlsx" |
*
* @param {Gc_Resources_Facts_Xlsx_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_facts_xlsx_value = /** @type {((inputs?: Gc_Resources_Facts_Xlsx_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Facts_Xlsx_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_facts_xlsx_value(inputs)
	return zh_gc_resources_facts_xlsx_value(inputs)
});
export { gc_resources_facts_xlsx_value as "gc.resources.facts.xlsx.value" }